module.exports = __webpack_public_path__ + "img/de-DE.55b5271f.svg";